import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntDirectoryInfoName } from "../../../../models/directoryInfoName";
import { useAddTypeEstatePurposeObjectMutation, useDeleteTypeEstatePurposeObjectMutation, useEditTypeEstatePurposeObjectMutation } from "../../../../redux/api/handBooksApi/typeEstatePurposeObjectApi";
import { getCookie } from "typescript-cookie";

const useTypeEstatePurposeObject = (modal: any, refresh?: () => void) => { 
    const { t } = useTranslation();
    const { confirm } = modal;
    const [addTypeEstatePurposeObject] = useAddTypeEstatePurposeObjectMutation();  
    const [deleteTypeEstatePurposeObject] = useDeleteTypeEstatePurposeObjectMutation(); 
    const [editTypeEstatePurposeObject] = useEditTypeEstatePurposeObjectMutation(); 

    async function onAddTypeEstatePurposeObject(newTypeEstatePurposeObject: EntDirectoryInfoName): Promise<boolean> {  
        try {
            let status: boolean = false;
            await addTypeEstatePurposeObject(newTypeEstatePurposeObject).then((response: any) => {  
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteTypeEstatePurposeObject(typeEstatePurposeObject: EntDirectoryInfoName) {  
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteTypeEstatePurposeObject(typeEstatePurposeObject.id as number).then((response: any) => {  
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditTypeEstatePurposeObject(editedTypeEstatePurposeObject: EntDirectoryInfoName): Promise<boolean> {  
        try {
            let status: boolean = false;
            await editTypeEstatePurposeObject(editedTypeEstatePurposeObject).then((response: any) => {  
                  if (response.error) {
                                              const isKyrgyz = getCookie('i18next') === 'ky';
                                              const lang = isKyrgyz ? 'kg' : 'ru';
                                              const res = response.error.data?.res;
                                              const errorMessages = Array.isArray(res)
                                                  ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                  : response.error.data?.msg || t('unknownError'); 
                                              throw new Error(errorMessages);
                                          }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddTypeEstatePurposeObject, onDeleteTypeEstatePurposeObject, onEditTypeEstatePurposeObject };  
}

export { useTypeEstatePurposeObject };  
